<div class="bundle-skeleton">
  <div class="bundle-skeleton-main">
    <div class="bundle-skeleton-header">
      <ngx-skeleton-loader
        [theme]="{height: '32px', width: '100%', 'border-radius': '0', margin: '0'}"
        appearance="line"
      ></ngx-skeleton-loader>
    </div>
    <div class="bundle-skeleton-banner">
      <ngx-skeleton-loader
        [theme]="{height: '72px', width: '100%', 'border-radius': '0', margin: '0'}"
        appearance="circle"
      ></ngx-skeleton-loader>
    </div>

    <div class="bundle-skeleton-slots">
      @for (slot of [1, 2]; track slot) {
        <div class="bundle-skeleton-slot">
          <div class="bundle-skeleton-slot-header">
            <ngx-skeleton-loader
              [theme]="{height: '24px', width: '40%', 'border-radius': '0', margin: '0'}"
              appearance="line"
            ></ngx-skeleton-loader>
            <ngx-skeleton-loader
              [theme]="{height: '16px', width: '16px', 'border-radius': '50%', margin: '0'}"
              appearance="circle"
            ></ngx-skeleton-loader>
          </div>

          <div class="bundle-skeleton-products">
            @for (product of [1, 2, 3, 4]; track product) {
              <div class="bundle-skeleton-product">
                <ngx-skeleton-loader
                  [theme]="{height: '176px', width: '100%', 'border-radius': '0', margin: '0'}"
                  appearance="circle"
                ></ngx-skeleton-loader>
                <ngx-skeleton-loader
                  [theme]="{height: '18px', width: '85%', 'border-radius': '0', margin: '0'}"
                  appearance="line"
                ></ngx-skeleton-loader>
                <ngx-skeleton-loader
                  [theme]="{height: '14px', width: '60%', 'border-radius': '0', margin: '0'}"
                  appearance="line"
                ></ngx-skeleton-loader>
                <ngx-skeleton-loader
                  [theme]="{height: '28px', width: '70px', 'border-radius': '0', margin: '8px 0 0 auto'}"
                  appearance="line"
                ></ngx-skeleton-loader>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>

  <div class="bundle-skeleton-summary">
    <div class="bundle-skeleton-summary-card">
      <ngx-skeleton-loader
        [theme]="{height: '24px', width: '60%', 'border-radius': '0', margin: '0'}"
        appearance="line"
      ></ngx-skeleton-loader>
      @for (item of [1, 2, 3, 4]; track item) {
        <div class="bundle-skeleton-summary-item">
          <ngx-skeleton-loader
            [theme]="{height: '24px', width: '24px', 'border-radius': '0', margin: '0'}"
            appearance="circle"
          ></ngx-skeleton-loader>
          <ngx-skeleton-loader
            [theme]="{height: '16px', width: '65%', 'border-radius': '0', margin: '0'}"
            appearance="line"
          ></ngx-skeleton-loader>
        </div>
      }
    </div>

    <div class="bundle-skeleton-summary-card">
      <ngx-skeleton-loader
        [theme]="{height: '24px', width: '70%', 'border-radius': '0', margin: '0'}"
        appearance="line"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        [theme]="{height: '48px', width: '100%', 'border-radius': '0', margin: '8px 0 0'}"
        appearance="line"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        [theme]="{height: '44px', width: '100%', 'border-radius': '0', margin: '8px 0 0'}"
        appearance="line"
      ></ngx-skeleton-loader>
    </div>
  </div>
</div>
